
const Vr17 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-17/PNG%20n.3/3d%2017-3/publish%2017-3/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 17 Tour"
        ></iframe>
      </div>
    );
};

export default Vr17;
